import { useRef, createContext, useCallback } from "react";

export const ErrorsContext = createContext({});

export function ErrorsContextProvider({ children }) {
  const verifyFunctions = useRef({});
  
  const addVerifyFunction = useCallback(({id, func, element}) => {
    verifyFunctions.current = {...verifyFunctions.current, [id]: {func, element}};
  }, []);
  
  const resetErrors = useCallback(() => {
    verifyFunctions.current = {};
  }, []);

  return (
    <ErrorsContext.Provider
      value={{
        verifyFunctions,
        addVerifyFunction,
        resetErrors
      }}
    >
    {children}
    </ErrorsContext.Provider>
  );
}